<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Permitted Promotions</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="promotion" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.promotion }}</td>
        <td class="text-xs-left">{{ props.item.promotionDesc }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" remove @remove="doPromptRemove(props.item)" :loading="loading"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-card-text>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
        Permit Promotion
        <v-icon right>mdi-star</v-icon>
      </v-btn>
    </v-card-text>
    <v-dialog v-model="addPromoDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Permit Promotion for Campaign</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete :label="labels.promotion" v-model="campaignPromoForm.promotion" :items="promotionList" item-text="label" item-value="value" :error-messages="errors.collect('promotion')" data-vv-name="promotion" :data-vv-as="labels.promotion" v-validate="'required'" :loading="promotionLoading"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Promotion?
      <div class="title">{{deleteCampaignPromo}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      headers: [
        { text: 'Promotion Code', align: 'left', value: 'promotion', sortable: false },
        { text: 'Promotion Description', align: 'left', value: 'promotionDesc', sortable: false },
        TableConst.tableActionHeader
      ],
      labels: {
        promotion: 'Promotion*'
      },
      campaignPromoForm: {
        campaign: undefined,
        promotion: undefined
      },
      totalItems: 0,
      loading: false,
      items: [],
      addPromoDialog: false,
      promotionLoading: false,
      promotionList: [],
      promptRemove: false,
      selectedCampaignPromo: undefined,
      deleteCampaignPromo: ''
    }
  },
  methods: {
    async doInit() {
      this.campaignPromoForm.campaign = this.campaign
      await this.queryCampaignPromotions()
    },
    async queryCampaignPromotions() {
      const apiURI = this.$store.state.promotionManagement.campaign.menu.campaignPromotions
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            campaign: this.campaign
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((campaignPromo) => {
                const convertCampaignPromo = {
                  campaign: campaignPromo.campaign,
                  campaignDesc: campaignPromo.campaignDesc,
                  promotion: campaignPromo.promotion,
                  promotionDesc: campaignPromo.promotionDesc
                }
                this.items.push(convertCampaignPromo)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getPromotions() {
      this.promotionLoading = true
      if (this.$store.state.promotionManagement.campaign.promotionList && this.$store.state.promotionManagement.campaign.promotionList.length > 0) {
        let result = []
        result = this.$store.state.promotionManagement.campaign.promotionList
        // Remove those that already permitted
        result = result.filter(promotion => {
          for (let permittedPromo of this.items) {
            if (permittedPromo.promotion === promotion.value) {
              return false
            }
          }
          return true
        })
        this.promotionList = result
      } else {
        this.promotionList = []
      }
      this.promotionLoading = false
    },
    doSave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doCreate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNew() {
      this.resetMessages()
      this.campaignPromoForm.promotion = undefined
      this.addPromoDialog = true
      this.getPromotions()
    },
    async doCreate() {
      const apiURI = this.$store.state.promotionManagement.campaign.menu.campaignPromotionCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.campaignPromoForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            this.doClose()
            // Fetch list again
            this.queryCampaignPromotions()
          }
          this.submitting = false
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doClose() {
      this.resetMessages()
      this.campaignPromoForm.promotion = undefined
      this.addPromoDialog = false
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedCampaignPromo = data
        this.deleteCampaignPromo = data.promotion + ' - ' + data.promotionDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.promotionManagement.campaign.menu.campaignPromotionDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          campaign: this.campaign,
          promotion: this.selectedCampaignPromo.promotion
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.queryCampaignPromotions()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  props: {
    campaign: {
      type: String,
      default: ''
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
